import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid sm:flex justify-between gap-4 items-stretch" }
const _hoisted_2 = { class: "flex justify-between py-2 border-b px-4 gap-4 absolute inset-x-0 z-30 top-0" }
const _hoisted_3 = { class: "overflow-y-scroll lg:overflow-y-auto h-64 lg:h-full" }
const _hoisted_4 = { class: "text-xs font-semibold text-gray-500 px-2 text-center" }
const _hoisted_5 = { class: "grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 divide-x divide-y" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "absolute top-0 bg-green-500 text-white text-xs px-2 rounded-b-lg left-2"
}
const _hoisted_8 = {
  key: 1,
  class: "absolute top-0 bg-green-500 text-white text-xs px-2 rounded-b-lg left-2"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "bg-rose-800 text-white text-xs px-2 rounded-se-lg rounded-es-lg mx-auto absolute left-2 bottom-7" }
const _hoisted_11 = { class: "text-xs mt-0.5" }
const _hoisted_12 = { class: "text-xs font-light text-gray-500 absolute bottom-0" }
const _hoisted_13 = {
  key: 1,
  class: "grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 divide-x divide-y"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "absolute top-0 bg-green-500 text-white text-xs px-2 rounded-b-lg left-2"
}
const _hoisted_16 = {
  key: 1,
  class: "absolute top-0 bg-green-500 text-white text-xs px-2 rounded-b-lg left-2"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "bg-rose-800 text-white text-xs px-2 rounded-se-lg rounded-es-lg mx-auto absolute left-2 bottom-7" }
const _hoisted_19 = { class: "text-xs mt-0.5" }
const _hoisted_20 = { class: "text-xs font-light text-gray-500 absolute bottom-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_lineup = _resolveComponent("lineup")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_lineup, {
      players: $data.lineup,
      onSelected: $options.onSelected,
      "active-player": $data.activePlayer
    }, null, 8 /* PROPS */, ["players", "onSelected", "active-player"]),
    _createCommentVNode(" Banca "),
    _createElementVNode("section", {
      class: _normalizeClass(["bg-white fixed z-10 lg:relative transition-all inset-x-0 rounded-t-lg border-2 border-black grow pt-12", $data.activePlayer ? 'bottom-0' : '-bottom-full'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-lg font-bold" }, " Banca ", -1 /* HOISTED */)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "border-2 border-black rounded-lg px-2 py-1 text-xs",
          placeholder: "Buscar jugador",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.query) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $data.query]
        ]),
        _createElementVNode("button", {
          class: "underline lg:hidden",
          onClick: _cache[1] || (_cache[1] = $event => ($data.activePlayer = null))
        }, " Cerrar ")
      ]),
      _createElementVNode("div", _hoisted_3, [
        ($data.query.length == 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($data.groupedPlayers, (players, position) => {
              return (_openBlock(), _createElementBlock("div", {
                key: position,
                class: "px-2 relative"
              }, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(position), 1 /* TEXT */),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(players, (player) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(["text-center py-2 px-1 relative transition-opacity hover:opacity-100", { 'opacity-100': $data.activePlayer && $data.activePlayer.position === player.position, 
							 'opacity-50': $data.activePlayer && $data.activePlayer.position !== player.position,
							'opacity-25': $data.lineup.find((p) => p.id === player.id) }]),
                      key: player.id,
                      onClick: $event => ($options.swapPlayer(player))
                    }, [
                      ($data.lineup.find((p) => p.id === player.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "T"))
                        : _createCommentVNode("v-if", true),
                      ($data.activePlayer && $data.activePlayer.id === player.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "A"))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("img", {
                        src: player.image,
                        alt: "",
                        class: "h-12 w-12 mx-auto object-cover rounded-full"
                      }, null, 8 /* PROPS */, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(player.number), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(player.nickname), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(player.country), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_6))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          : (_openBlock(), _createElementBlock("ul", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredPlayers, (player) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["text-center py-2 px-1 relative transition-opacity hover:opacity-100", { 'opacity-100': $data.activePlayer && $data.activePlayer.position === player.position, 'opacity-50': $data.activePlayer && $data.activePlayer.position !== player.position }]),
                  key: player.id,
                  onClick: $event => ($options.swapPlayer(player))
                }, [
                  ($data.lineup.find((p) => p.id === player.id))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, "T"))
                    : _createCommentVNode("v-if", true),
                  ($data.activePlayer && $data.activePlayer.id === player.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, "A"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("img", {
                    src: player.image,
                    alt: "",
                    class: "h-12 w-12 mx-auto object-cover rounded-full"
                  }, null, 8 /* PROPS */, _hoisted_17),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(player.number), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(player.nickname), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(player.country), 1 /* TEXT */)
                ], 10 /* CLASS, PROPS */, _hoisted_14))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
      ])
    ], 2 /* CLASS */),
    _cache[6] || (_cache[6] = _createElementVNode("section", null, " Compartir ", -1 /* HOISTED */)),
    _createElementVNode("section", null, [
      _cache[3] || (_cache[3] = _createTextVNode(" // share screen Copiar enlace ")),
      _createElementVNode("code", null, "https://www.futbol5.com/lineup/" + _toDisplayString($data.id), 1 /* TEXT */),
      _cache[4] || (_cache[4] = _createElementVNode("button", null, " Copiar ", -1 /* HOISTED */)),
      _cache[5] || (_cache[5] = _createTextVNode(" Whatsapp Twitter // crear foto Donwload foto "))
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("section", null, " Shared with you ", -1 /* HOISTED */))
  ]))
}